export const homeCampaign = 'home_mobile_web_listen_button';
export const profileCampaign = 'mobile_web_listen_button';
export const playCampaign = 'mobile_web_play_button';

export const channel = 'mobile.tunein.com';
